import React from 'react';
import { Header } from './components/Header';
import { VideoPlayer } from './components/VideoPlayer';
import { WhoThisIsFor } from './components/WhoThisIsFor';
import { WhatWeDo } from './components/WhatWeDo';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function App() {
  const openTypeform = () => {
    window.location.href = 'https://form.typeform.com/to/w7LMrDGe';
  };
  return <div className="w-full min-h-screen bg-[#020311]" data-id="element-0">
      {/* Hero Section with Vibrant Blue-Purple Gradient */}
      <div className="relative overflow-hidden" data-id="element-1">
        {/* Vibrant gradient background - darker at bottom for button contrast */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#0066FF] via-[#6B3FFF] to-[#020311]" data-id="element-2" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_30%,rgba(0,102,255,0.3),transparent_40%)]" data-id="element-3" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(107,63,255,0.25),transparent_40%)]" data-id="element-4" />

        {/* Floating geometric shapes - hidden on mobile for performance */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none hidden sm:block" data-id="element-5">
          <motion.div animate={{
          y: [0, -20, 0],
          rotate: [0, 5, 0]
        }} transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute top-20 left-10 w-32 h-32 border border-white/10 rounded-lg" data-id="element-6" />
          <motion.div animate={{
          y: [0, 20, 0],
          rotate: [0, -5, 0]
        }} transition={{
          duration: 10,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute top-40 right-20 w-24 h-24 border border-white/10 rounded-full" data-id="element-7" />
          <motion.div animate={{
          y: [0, -15, 0],
          x: [0, 10, 0]
        }} transition={{
          duration: 12,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute bottom-40 left-1/4 w-20 h-20 border border-white/10 rounded-lg rotate-45" data-id="element-8" />
        </div>

        <div className="relative z-10" data-id="element-9">
          <Header data-id="element-10" />
          <main className="max-w-6xl mx-auto px-4" data-id="element-11">
            {/* Hero Section */}
            <div id="headline" className="pb-8 sm:pb-12 md:pb-20" data-id="element-12">
              {/* Eyebrow Text */}
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6
            }} className="text-center text-xs sm:text-sm font-semibold tracking-wide uppercase mb-3 sm:mb-4 text-[#F5F5F7]/80" data-id="element-13">
                For CEOs & sales leaders doing $1M/YR ONLY...
              </motion.p>

              <motion.h1 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.1
            }} className="text-center text-[2rem] leading-[1.15] sm:text-5xl sm:leading-[1.2] md:text-6xl font-black mb-4 sm:mb-6 md:mb-8 max-w-4xl mx-auto text-[#F5F5F7]" data-id="element-14">
                You Don't Have a Talent Problem. You Have an Operating System
                Problem.
              </motion.h1>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="text-center text-base sm:text-lg md:text-xl mb-8 sm:mb-12 md:mb-16 text-[#F5F5F7]/90 max-w-4xl mx-auto leading-relaxed" data-id="element-15">
                Watch the training to see how we install the $100M Sales Team OS
                in 120 days so your current reps sell like your top 10% –
                without unicorn hires or extra SDRs.
              </motion.p>

              {/* Video Player */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.6,
              delay: 0.4
            }} className="mb-6 sm:mb-8" data-id="element-16">
                <VideoPlayer data-id="element-17" />
              </motion.div>

              {/* Step 2 CTA */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.6
            }} className="text-center py-4 sm:py-8" data-id="element-18">
                <p className="text-[#F5F5F7] text-base sm:text-lg md:text-xl font-semibold mb-4 sm:mb-6" data-id="element-19">
                  <span className="font-bold" data-id="element-20">Step 2:</span> Book your Sales OS
                  Audit Call
                </p>
                <motion.button onClick={openTypeform} whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="inline-flex items-center gap-2 py-3 px-6 sm:py-4 sm:px-8 text-[#F5F5F7] font-bold rounded-lg text-sm sm:text-lg md:text-xl bg-gradient-to-r from-[#6366F1] to-[#7C3AED] hover:shadow-[0_0_40px_rgba(124,58,237,0.6)] transition-all duration-300 shadow-xl whitespace-nowrap" data-id="element-21">
                  Book Your Sales OS Audit Call
                  <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-22" />
                </motion.button>
              </motion.div>
            </div>
          </main>
        </div>
      </div>

      {/* Main Content */}
      <main className="max-w-6xl mx-auto px-4 relative" data-id="element-23">
        {/* Subtle grid pattern overlay */}
        <div className="absolute inset-0 pointer-events-none opacity-[0.02]" data-id="element-24">
          <div className="absolute inset-0" style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }} data-id="element-25" />
        </div>

        {/* What We Do Section */}
        <div id="what-we-do" className="relative" data-id="element-26">
          <WhatWeDo data-id="element-27" />
        </div>

        {/* Who This Is For Section */}
        <div id="who-this-is-for" className="relative" data-id="element-28">
          <WhoThisIsFor data-id="element-29" />
        </div>

        {/* FAQ Section */}
        <div id="faq" className="relative" data-id="element-30">
          <FAQSection data-id="element-31" />
        </div>

        {/* Final CTA Section */}
        <div id="final-cta" className="relative" data-id="element-32">
          <FinalCTA data-id="element-33" />
        </div>

        <Footer data-id="element-34" />
      </main>
    </div>;
}